module.exports = __webpack_public_path__ + "img/arrow-right-dark.dba56c9.svg";